import { Utility } from '../utility/utility_controller'

var $grids

var onResize = function () {
	if (typeof $grids != 'undefined') {
		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			setColOrderAndLastClass($el, config)
			setCSS($el, config)
		})
	}
}

var isAuto = function (myString) {
	return isNaN(Number(myString)) || myString.trim() === ''
}

var setColOrderAndLastClass = function ($el, config) {
	var sortedColumnsInConfig = config[Utility.screenSize].sortedColumns
	var target_order = []
	var target_visibles = []
	for (var index = 0; index < sortedColumnsInConfig.length; index++) {
		var element = sortedColumnsInConfig[index]

		target_order.push(element['name'])
		target_visibles.push(element['visible'])
	}

	// get values

	// sort rows and set "last visible class", row by row, because col could be empty, i set the one before as the last visible one
	// need this to hide correct separator for comma list type style

	// first order filter

	var orders = []
	var biggestVisibleOrderForRow = -1
	var biggestVisibleOrderForRowDomElementIx = -1
	$el.find('.lay-productindex-filter').each(function (ix) {
		var order = 0
		if (this.classList.contains('lay-productindex-filter-title')) {
			order = target_order.indexOf('title')
		} else if (this.classList.contains('lay-productindex-filter-categories')) {
			order = target_order.indexOf('categories')
		} else if (this.classList.contains('lay-productindex-filter-tags')) {
			order = target_order.indexOf('tags')
		} else if (this.classList.contains('lay-productindex-filter-year')) {
			order = target_order.indexOf('year')
		}
		jQuery(this).css('order', order)

		if (order > biggestVisibleOrderForRow && target_visibles[order] == true) {
			biggestVisibleOrderForRow = order
			biggestVisibleOrderForRowDomElementIx = ix
		}
	})
	$el.find('.lay-productindex-filter-wrap').find('.last-visible-productindex-col').removeClass('last-visible-productindex-col')
	if (biggestVisibleOrderForRowDomElementIx != -1) {
		$el.find('.lay-productindex-filter:nth-child(' + (biggestVisibleOrderForRowDomElementIx + 1) + ')').addClass('last-visible-productindex-col')
	}

	// order divs inside rows

	$el.find('.lay-productindex-row').each(function () {
		var $row = jQuery(this)

		var biggestVisibleOrderForRow = -1
		var biggestVisibleOrderForRowDomElementIx = -1
		// orders = [];
		$row.find('>div').each(function (ix) {
			var order = 0
			switch (this.classList[0]) {
				case 'lay-productindex-col-title':
					order = target_order.indexOf('title')
					break
				case 'lay-productindex-col-categories':
					order = target_order.indexOf('categories')
					break
				case 'lay-productindex-col-tags':
					order = target_order.indexOf('tags')
					break
				case 'lay-productindex-col-year':
					order = target_order.indexOf('year')
					break
			}
			jQuery(this).css('order', order)
			// orders.push(order);
			if (order > biggestVisibleOrderForRow && target_visibles[order] == true && !this.classList.contains('lay-productindex-col-empty')) {
				biggestVisibleOrderForRow = order
				biggestVisibleOrderForRowDomElementIx = ix
			}
		})

		$row.find('.last-visible-productindex-col').removeClass('last-visible-productindex-col')
		if (biggestVisibleOrderForRowDomElementIx != -1) {
			$row.find('>div:nth-child(' + (biggestVisibleOrderForRowDomElementIx + 1) + ')').addClass('last-visible-productindex-col')
			// $row.find('.lay-productindex-filter:nth-child('+(biggestVisibleOrderForRowDomElementIx+1)+')').addClass('last-visible-productindex-col')
		}
	})
}

var setCSS = function ($el, config) {
	var $title = $el.find('.lay-productindex-col-title, .lay-productindex-filter-title')
	var $categories = $el.find('.lay-productindex-col-categories, .lay-productindex-filter-categories')
	var $tags = $el.find('.lay-productindex-col-tags, .lay-productindex-filter-tags')
	var $year = $el.find('.lay-productindex-col-year, .lay-productindex-filter-year')

	var style = typeof config.style == 'undefined' ? 'table' : config.style

	// we say width is "auto" if width is anything other than a number
	var tagsWidthIsAuto = isAuto(config[Utility.screenSize].tagsWidth)
	var categoriesWidthIsAuto = isAuto(config[Utility.screenSize].categoriesWidth)

	var titleWidthIsAuto = isAuto(config[Utility.screenSize].titleWidth)

	var yearWidthIsAuto = isAuto(config[Utility.screenSize].yearWidth)

	var titleVisible, categoriesVisible, tagsVisible, yearVisible

	for (var index = 0; index < config[Utility.screenSize].sortedColumns.length; index++) {
		var col = config[Utility.screenSize].sortedColumns[index]
		switch (col.name) {
			case 'title':
				titleVisible = col.visible
				break
			case 'categories':
				categoriesVisible = col.visible
				break
			case 'year':
				yearVisible = col.visible
				break
			case 'tags':
				tagsVisible = col.visible
				break
		}
	}

	var visibleCols = []
	for (var index = 0; index < config[Utility.screenSize].sortedColumns.length; index++) {
		var col = config[Utility.screenSize].sortedColumns[index]
		if (col.visible === true) {
			visibleCols.push(col)
		}
	}

	// when a col width is auto, the remaining width ( 100 - custom widths ) is split evenly between the auto widths
	// so first we need to calculate the "widthToSplitEvenly", then we can calculate the auto width per auto col
	var widthToSplitEvenly = 100
	var titleWidth, categoriesWidth, tagsWidth, yearWidth
	var visibleColumnsAmount = visibleCols.length
	var autoWidthColumnsAmount = visibleColumnsAmount

	// calculate widthToSplitEvenly
	for (var index = 0; index < visibleCols.length; index++) {
		var col = visibleCols[index]
		switch (col.name) {
			case 'title':
				if (!titleWidthIsAuto) {
					widthToSplitEvenly -= Number(config[Utility.screenSize].titleWidth)
					autoWidthColumnsAmount--
				}
				break
			case 'categories':
				if (!categoriesWidthIsAuto) {
					widthToSplitEvenly -= Number(config[Utility.screenSize].categoriesWidth)
					autoWidthColumnsAmount--
				}
				break
			case 'tags':
				if (!tagsWidthIsAuto) {
					widthToSplitEvenly -= Number(config[Utility.screenSize].tagsWidth)
					autoWidthColumnsAmount--
				}
				break
			case 'year':
				if (yearWidthIsAuto) {
					// if year width is auto give it a 15% width
					// thats just my design decision
					yearWidth = 15
					widthToSplitEvenly -= yearWidth
					autoWidthColumnsAmount--
				} else {
					widthToSplitEvenly -= Number(config[Utility.screenSize].yearWidth)
					autoWidthColumnsAmount--
				}
				break
		}
	}

	for (var index = 0; index < visibleCols.length; index++) {
		var col = visibleCols[index]
		switch (col.name) {
			case 'title':
				if (titleWidthIsAuto) {
					titleWidth = widthToSplitEvenly / autoWidthColumnsAmount
				} else {
					titleWidth = config[Utility.screenSize].titleWidth
				}
				break
			case 'categories':
				if (categoriesWidthIsAuto) {
					categoriesWidth = widthToSplitEvenly / autoWidthColumnsAmount
				} else {
					categoriesWidth = config[Utility.screenSize].categoriesWidth
				}
				break
			case 'tags':
				if (tagsWidthIsAuto) {
					tagsWidth = widthToSplitEvenly / autoWidthColumnsAmount
				} else {
					tagsWidth = config[Utility.screenSize].tagsWidth
				}
				break
			case 'year':
				if (yearWidthIsAuto) {
					// if year width is auto give it a 15% width
					// thats just my design decision
					yearWidth = 15
				} else {
					yearWidth = config[Utility.screenSize].yearWidth
				}
				break
		}
	}

	// set css
	if (tagsVisible) {
		$tags.show()
		if (style == 'table') {
			$tags.css('width', tagsWidth + '%')
		}
	} else {
		$tags.hide()
	}

	if (categoriesVisible) {
		$categories.show()
		if (style == 'table') {
			$categories.css('width', categoriesWidth + '%')
		}
	} else {
		$categories.hide()
	}

	if (yearVisible) {
		$year.show()
		if (style == 'table') {
			$year.css('width', yearWidth + '%')
		}
	} else {
		$year.hide()
	}

	if (titleVisible) {
		$title.show()
		if (style == 'table') {
			$title.css('width', titleWidth + '%')
		}
	} else {
		$title.hide()
	}
}

var bindFilterClick = function ($grid, config) {
	$grid.find('.lay-productindex-filter-inner').off('click')
	$grid.find('.lay-productindex-filter-inner').on('click', function () {
		var $filterButton = jQuery(this.parentNode)
		var $productIndex = jQuery(this).closest('.lay-productindex')
		var $rows = $productIndex.find('.lay-productindex-row')
		var order = 'DESC'

		if ($filterButton.hasClass('productindex-filter-active')) {
			if ($filterButton.hasClass('order-ASC')) {
				$filterButton.removeClass('order-ASC').addClass('order-DESC')
				order = 'DESC'
			} else {
				$filterButton.removeClass('order-DESC').addClass('order-ASC')
				order = 'ASC'
			}
		} else {
			$productIndex.find('.productindex-filter-active').removeClass('productindex-filter-active')
			if ($filterButton.hasClass('lay-productindex-filter-year')) {
				$filterButton.removeClass('order-ASC').addClass('productindex-filter-active order-DESC')
				order = 'DESC'
			} else {
				$filterButton.removeClass('order-DESC').addClass('productindex-filter-active order-ASC')
				order = 'ASC'
			}
		}
		var orderby = ''
		if ($filterButton.hasClass('lay-productindex-filter-title')) {
			orderby = 'title'
		} else if ($filterButton.hasClass('lay-productindex-filter-categories')) {
			orderby = 'categories'
		} else if ($filterButton.hasClass('lay-productindex-filter-tags')) {
			orderby = 'tags'
		} else if ($filterButton.hasClass('lay-productindex-filter-year')) {
			orderby = 'date'
		}

		var array = []
		$rows.each(function (ix) {
			switch (orderby) {
				case 'title':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-productindex-col-title').text(),
					})
					break
				case 'categories':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-productindex-col-categories').text(),
					})
					break
				case 'tags':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-productindex-col-tags').text(),
					})
					break
				case 'date':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-productindex-col-year').attr('data-date'),
					})
					break
			}
		})

		// sort
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
		switch (orderby) {
			case 'title':
			case 'categories':
				array.sort((a, b) => a.text.localeCompare(b.text))
				break
			case 'tags':
				// natural sort in case someone uses numbers for tags
				// https://stackoverflow.com/questions/2802341/javascript-natural-sort-of-alphanumerical-strings
				array.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
				break
			case 'date':
				array.sort(function (a, b) {
					var numberA = parseInt(a.text, 10) // ignore upper and lowercase
					var numberB = parseInt(b.text, 10) // ignore upper and lowercase
					return numberA - numberB
				})
				break
		}

		if (order == 'DESC') {
			array = array.reverse()
		}

		jQuery('.lay-productindex-first-row').css('border-top', '')
		jQuery('.lay-productindex-first-row').removeClass('lay-productindex-first-row')
		for (var index = 0; index < array.length; index++) {
			var element = array[index]
			$rows.eq(element.domIx).css('order', index)
			if (index == 0) {
				$rows.eq(element.domIx).addClass('lay-productindex-first-row')
			}
		}
		jQuery('.lay-productindex-first-row').css('border-top', config.lineStrokeWidth + 'px solid ' + config.lineColor)
		window.laytheme.emit('productindex_reordered')
	})
}

var i = function () {
	window.laytheme.on('sizechanged', onResize)
	bindOnNewpageShown()
}

var bindOnNewpageShown = function () {
	window.laytheme.on('newpageshown', function () {
		$grids = jQuery('.lay-productindex')

		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			setColOrderAndLastClass($el, config)
			setCSS($el, config)
			bindFilterClick($el, config)
			this.classList.add('initialized')
		})

		// change active class, for when we use splitscreen layout and "Never change scrolling position when navigating"
		// because then this markup may not be switched out with the latest version!
		$grids.each(function () {
			var $el = jQuery(this)
			var idOfCurrentlyActiveProductindexInElement = $el.find('.lay-product-index-current-product .productindex-product-link').attr('data-id')
			var idOfCurrentlyShownProduct = jQuery('body').attr('data-id')
			if (idOfCurrentlyShownProduct != idOfCurrentlyActiveProductindexInElement) {
				$el.find('.lay-product-index-current-product').removeClass('lay-product-index-current-product')
				$el.find('.productindex-product-link[data-id="' + idOfCurrentlyShownProduct + '"]')
					.closest('.lay-productindex-row')
					.addClass('lay-product-index-current-product')
			}
		})
	})
}

var productindex_controller = {
	i: i,
}

export default productindex_controller
